var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseRounded(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 14,
    viewBox: "0 0 13 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.1662 11.5757C8.72543 14.0164 4.76813 14.0164 2.32738 11.5757C-0.113402 9.13489 -0.113402 5.17761 2.32738 2.73683C4.76813 0.296077 8.72543 0.296055 11.1662 2.73683C13.607 5.17759 13.607 9.13491 11.1662 11.5757ZM5.86291 7.15625L4.09514 8.92402L4.97903 9.8079L6.74679 8.04013L8.51456 9.8079L9.39844 8.92402L7.63068 7.15625L9.39844 5.38848L8.51456 4.5046L6.74679 6.27237L4.97903 4.5046L4.09514 5.38848L5.86291 7.15625Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseRounded);
export default __webpack_public_path__ + "static/media/close_rounded.21089aab7eb5fead5b80de719815c0fb.svg";
export { ForwardRef as ReactComponent };